import { InputFieldSize } from '../InputField.types';

/** Maps InputFieldSize to vertical padding values */
export const VERTICAL_PADDING: Record<InputFieldSize, number> = {
  small: 8,
  medium: 8,
  large: 10
};

export const TEXT_AREA_ID = 'textAreaId';
